import Flickity from "flickity";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

document.addEventListener("DOMContentLoaded", function () {
  const listButton = document.querySelector(".listbutton");
  const gridButton = document.querySelector(".gridbutton");
  const eventContent = document.querySelector(".eventcontent");
  const bookingForm = document.getElementById("buchungsform");
  const keyWordField = document.getElementById("keyword");
  const categoryField = document.getElementById("categoryevent");
  const startDatePicker = document.querySelector("#startdateevent");
  const endDatePicker = document.querySelector("#enddateevent");
  const filterStatus = document.getElementById("event-filter-status");
  const eventArchive = document.getElementById("evcal");
  const resultsList = document.getElementById("event-results");
  const countElement = document.querySelector(".ws-event-toolbar__count");
  const paginationHolder = document.querySelector(".event-pagination-holder");
  const resetHolder = document.querySelector("[data-event-filter-reset]");
  const submitButton = document.querySelector(".ws-event-filter__submit");
  const restUrl =
    (window.weissenstadt_evcal_object &&
      window.weissenstadt_evcal_object.restUrl) ||
    "";
  const archiveSettings = window.weissenstadt_evcal_object || {};
  const usesPrettyPermalinks = archiveSettings.usesPrettyPermalinks !== false;
  const paginationBase = archiveSettings.paginationBase || "page";
  const dateInputFormat = "DD.MM.YYYY";
  const urlDateFormats = ["YYYY-MM-DD", "YYYYMMDD", "DD.MM.YYYY"];

  // The start field's value at the moment its calendar opened. onClose compares
  // against it to decide whether a date was actually chosen — see
  // maybeAdvanceToEndPicker().
  let startValueOnOpen = "";
  // Same snapshot trick for the end field — see its onClose.
  let endValueOnOpen = "";
  // Monotonic request id. A slow response for an abandoned filter must never
  // overwrite the results of a newer one.
  let activeRequest = 0;
  let activeRequestController = null;
  let activeCountsRequest = 0;
  let categoryChangeTimer = null;
  let dateChangeTimer = null;
  let submitHadFocus = false;

  if (!eventContent || !startDatePicker || !endDatePicker) {
    return;
  }

  if (listButton && gridButton) {
    setViewMode(eventContent.classList.contains("listview") ? "list" : "grid");

    listButton.addEventListener("click", function () {
      setViewMode("list");
    });

    gridButton.addEventListener("click", function () {
      setViewMode("grid");
    });
  }

  const slider = document.querySelector(".evalsliderinit");

  if (slider) {
    new Flickity(slider, {
      lazyLoad: true,
      adaptiveHeight: true,
      prevNextButtons: true,
      pageDots: false,
      fullscreen: true,
    });
  }

  const today = dayjs();
  const defaultEndDate = dayjs().add(defaultRangeMonths(), "month");
  const initialUrlState = getUrlState();
  const initialStartDate = initialUrlState.start || today;
  const initialEndDate = getSafeEndDate(
    initialStartDate,
    initialUrlState.end || defaultEndDate
  );

  if (keyWordField) {
    keyWordField.value = initialUrlState.search;
  }

  if (categoryField) {
    categoryField.value = initialUrlState.category;
  }

  const startpicker = flatpickr("#startdateevent", {
    dateFormat: "d.m.Y",
    ariaDateFormat: "l, d. F Y",
    allowInput: true,
    locale: "de",
    enableTime: false,
    firstDayOfWeek: 1,
    defaultDate: initialStartDate.format("DD.MM.YYYY"),
    onReady: function (_selectedDates, _dateObj, instance) {
      improveDatepickerAccessibility(instance, "Startdatum auswählen");
    },
    onOpen: function () {
      startValueOnOpen = startDatePicker.value;
    },
    onClose: function (selectedDates, dateObj) {
      const selectedDate = getSelectedDay(selectedDates, dateObj);
      // Snapshot comparison rather than a flag set in onChange: by the time
      // flatpickr fires onChange for a day click its `isOpen` is already false,
      // so an isOpen guard there never matched. Comparing the value the field
      // had when the calendar opened works for clicks, keyboard selection and
      // typing alike, and stays quiet when the calendar is opened and dismissed
      // without a choice.
      const pickedSomething = startDatePicker.value !== startValueOnOpen;

      startValueOnOpen = startDatePicker.value;

      if (!selectedDate.isValid()) {
        setDateInputError(startDatePicker);
        return;
      }

      clearDateInputError(startDatePicker);

      const selectedLabel = selectedDate.format("DD.MM.YYYY");
      const endDate = getPickerDay(endDatePicker);

      startDatePicker.setAttribute("placeholder", selectedLabel);
      endpicker.set("minDate", selectedLabel);

      if (!endDate.isValid() || endDate.isBefore(selectedDate, "day")) {
        endDatePicker.setAttribute("placeholder", selectedLabel);
        endpicker.setDate(selectedLabel);
      }

      scheduleCategoryCountRefresh();

      if (pickedSomething) {
        maybeAdvanceToEndPicker();
      }
    },
  });

  const endpicker = flatpickr("#enddateevent", {
    dateFormat: "d.m.Y",
    ariaDateFormat: "l, d. F Y",
    allowInput: true,
    locale: "de",
    enableTime: false,
    firstDayOfWeek: 1,
    defaultDate: initialEndDate.format("DD.MM.YYYY"),
    minDate: initialStartDate.format("DD.MM.YYYY"),
    onReady: function (_selectedDates, _dateObj, instance) {
      improveDatepickerAccessibility(instance, "Enddatum auswählen");
    },
    onOpen: function () {
      endValueOnOpen = endDatePicker.value;
    },
    onClose: function (selectedDates, dateObj) {
      const selectedDate = getSelectedDay(selectedDates, dateObj);
      const pickedSomething = endDatePicker.value !== endValueOnOpen;

      endValueOnOpen = endDatePicker.value;

      if (!selectedDate.isValid()) {
        setDateInputError(endDatePicker);
        return;
      }

      clearDateInputError(endDatePicker);
      endDatePicker.setAttribute(
        "placeholder",
        selectedDate.format("DD.MM.YYYY")
      );

      if (!pickedSomething) {
        return;
      }

      // The end date completes the range, so this is where the result list
      // follows — picking a start date only refreshes the category counts,
      // because at that moment the visitor is still mid-selection (focus has
      // just been handed to this field). applyFilters brings fresh counts with
      // it, so no separate count request here.
      const filterState = getFilterState();

      if (filterState) {
        applyFilters(filterState);
      }
    },
  });

  applyDateFields(initialStartDate, initialEndDate);

  [startDatePicker, endDatePicker].forEach(function (input) {
    input.addEventListener("input", function () {
      if (getPickerDay(input).isValid()) {
        clearDateInputError(input);
      }
    });
  });

  bookingForm?.addEventListener("submit", function (event) {
    event.preventDefault();
    const filterState = getFilterState();

    if (!filterState) {
      return;
    }

    setFilterStatus("");
    // No focusResults: submitting the filter — by button or by Return in the
    // search field — must not move the viewport. The result count carries
    // aria-live, so the new total is announced without relocating anyone, and
    // focus stays in the field being refined.
    applyFilters(filterState);
  });

  // Choosing a category filters straight away — no second click on the button.
  // Debounced because a <select> fires `change` on every arrow-key step in
  // Firefox and Safari, which would otherwise mean one request per keystroke.
  categoryField?.addEventListener("change", function () {
    window.clearTimeout(categoryChangeTimer);
    categoryChangeTimer = window.setTimeout(function () {
      const filterState = getFilterState();

      if (filterState) {
        // No focus move here: the pointer/caret stays in the select the user
        // is still operating.
        applyFilters(filterState);
      }
    }, 350);
  });

  // Pagination stays real <a href> markup — crawlable, middle-clickable, and
  // fully working without JS — and is only upgraded to a fetch here.
  paginationHolder?.addEventListener("click", function (event) {
    const link = event.target.closest("a.page-numbers");

    if (!link || !paginationHolder.contains(link) || isModifiedClick(event)) {
      return;
    }

    const filterState = getFilterState();

    if (!filterState) {
      return;
    }

    event.preventDefault();
    // The server-rendered href is the canonical source. Restrict it to public
    // archive parameters so an old cached fragment cannot reintroduce REST
    // query variables.
    applyFilters(filterState, {
      page: getPageFromUrl(link.href),
      url: sanitizeArchiveUrl(link.href),
      focusResults: true,
    });
  });

  resetHolder?.addEventListener("click", function (event) {
    const link = event.target.closest("a");

    if (!link || isModifiedClick(event)) {
      return;
    }

    event.preventDefault();
    resetFilterFields();
    applyFilters(
      { start: today, end: defaultEndDate, search: "", category: "" },
      // No focusResults here: resetting should not move the viewport. Focus
      // still has to go somewhere, though — this link is about to be hidden,
      // and a hidden activeElement drops focus to <body>. The submit button is
      // the nearest stable control and is already on screen, so handing focus
      // there keeps the keyboard user in the filter and scrolls nothing. Not
      // the date field: with allowInput, focusing it pops the calendar open.
      { url: link.href, focusAfter: submitButton }
    );
  });

  // Back/forward must land on the state the URL describes, not on whatever the
  // fields happen to hold.
  window.addEventListener("popstate", function () {
    const urlState = getUrlState();
    const startDate = urlState.start || today;
    const endDate = getSafeEndDate(startDate, urlState.end || defaultEndDate);
    const filterState = {
      start: startDate,
      end: endDate,
      search: urlState.search,
      category: urlState.category,
    };

    syncFieldsToState(filterState);
    applyFilters(filterState, { page: getPageFromUrl(), push: false });
  });

  /**
   * Fetch a filtered result set and swap it in, keeping the URL shareable.
   *
   * Falls back to a full page load whenever the fetch cannot be trusted — no
   * endpoint, network error, bad status — so a filter click always ends in
   * results rather than in a silently stale list.
   */
  function applyFilters(filterState, options) {
    const settings = options || {};
    const page = Math.max(1, settings.page || 1);
    const targetUrl = settings.url || buildArchiveUrl(filterState, page);

    if (!restUrl || !resultsList) {
      window.location.href = targetUrl;
      return;
    }

    const requestId = ++activeRequest;
    activeRequestController?.abort();

    const controller =
      typeof window.AbortController === "function"
        ? new window.AbortController()
        : null;
    activeRequestController = controller;

    // Mobile networks can stall without failing; without a timeout the list
    // stays dimmed with pointer-events:none indefinitely.
    const timeoutId = window.setTimeout(function () {
      if (requestId !== activeRequest) {
        return;
      }

      if (controller) {
        controller.abort();
        return;
      }

      navigateToArchive(targetUrl, requestId);
    }, 15000);

    setLoadingState(true);

    window
      .fetch(buildRestUrl(filterState, page), {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        signal: controller ? controller.signal : undefined,
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unerwarteter Status " + response.status);
        }

        return response.json();
      })
      .then(function (payload) {
        if (requestId !== activeRequest) {
          return;
        }

        renderResults(payload, filterState);
        setLoadingState(false);

        if (false !== settings.push) {
          window.history.pushState({ weissenstadtEvents: true }, "", targetUrl);
        }

        if (settings.focusResults) {
          scrollToFirstResult();
        } else if (settings.focusAfter) {
          // preventScroll: the caller picked this target precisely because it
          // wants focus moved without the viewport following.
          settings.focusAfter.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        if (requestId !== activeRequest) {
          return;
        }

        navigateToArchive(targetUrl, requestId);
      })
      .finally(function () {
        window.clearTimeout(timeoutId);

        if (activeRequestController === controller) {
          activeRequestController = null;
        }
      });
  }

  function navigateToArchive(targetUrl, requestId) {
    if (requestId !== activeRequest) {
      return;
    }

    // Invalidate a response that wins the race after navigation has started.
    activeRequest += 1;
    setFilterStatus("Die Veranstaltungen werden neu geladen.");
    window.location.href = targetUrl;
  }

  /**
   * After a page change, put the first event at the top of the viewport.
   *
   * Focusing the whole results list used to scroll unpredictably (sticky header
   * + tall <ul> meant the browser often stopped mid-list). Scroll the first card
   * explicitly, then move focus without a second scroll for screen readers.
   */
  function scrollToFirstResult() {
    if (!resultsList) {
      return;
    }

    const firstResult =
      resultsList.querySelector(".event-card-item") ||
      resultsList.querySelector(".keinevent") ||
      resultsList;
    const prefersReducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (typeof firstResult.scrollIntoView === "function") {
      firstResult.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "start",
      });
    }

    if (typeof resultsList.focus === "function") {
      resultsList.focus({ preventScroll: true });
    }
  }

  /**
   * Refresh the per-category counts for whatever range the fields now hold.
   *
   * Deliberately does not touch the result list: the numbers describe the range
   * the visitor is assembling, before they commit to it with the button.
   */
  function scheduleCategoryCountRefresh() {
    window.clearTimeout(dateChangeTimer);
    dateChangeTimer = window.setTimeout(function () {
      const startDate = getPickerDay(startDatePicker);
      const endDate = getPickerDay(endDatePicker);

      if (
        !categoryField ||
        !restUrl ||
        !startDate.isValid() ||
        !endDate.isValid()
      ) {
        return;
      }

      const url = new URL(
        restUrl.replace(/\/events\/?$/, "/event-category-counts"),
        window.location.origin
      );
      url.searchParams.set("start", startDate.format("YYYYMMDD"));
      url.searchParams.set(
        "end",
        getSafeEndDate(startDate, endDate).format("YYYYMMDD")
      );

      const searchTerm = (keyWordField?.value || "").trim();

      if (searchTerm) {
        url.searchParams.set("search", searchTerm);
      }

      const requestId = ++activeCountsRequest;

      window
        .fetch(url.toString(), {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (payload) {
          if (payload && requestId === activeCountsRequest) {
            applyCategoryCounts(payload.categories);
          }
        })
        .catch(function () {
          // Counts are a convenience. If they cannot be refreshed the previous
          // numbers simply stay — never break filtering over a label.
        });
    }, 250);
  }

  function applyCategoryCounts(categories) {
    if (!categoryField || !Array.isArray(categories)) {
      return;
    }

    const bySlug = {};

    categories.forEach(function (category) {
      bySlug[category.slug] = category;
    });

    const selected = categoryField.value;

    Array.prototype.forEach.call(categoryField.options, function (option) {
      const category = option.value && bySlug[option.value];

      if (!category) {
        return;
      }

      // textContent, not innerHTML — the label is data from the endpoint.
      option.textContent = category.label;
      // Mirrors the PHP render: an empty category is a dead end, so it stays
      // visible (the number is the information) but cannot be chosen — except
      // when it is the filter already in effect.
      option.disabled = 0 === category.count && option.value !== selected;
    });
  }

  function renderResults(payload, filterState) {
    // payload.html is markup this theme rendered and escaped server-side
    // (weissenstadt_event_render_cards), served from our own REST route.
    resultsList.innerHTML = payload.html || "";

    if (!payload.count) {
      const emptyMessage = document.createElement("p");
      emptyMessage.className = "keinevent";
      emptyMessage.textContent =
        "Aktuell wurden leider keine Veranstaltungen gefunden.";
      resultsList.appendChild(emptyMessage);
    }

    if (countElement) {
      // aria-live on this element announces the new total.
      countElement.textContent = payload.count_label || "";
    }

    applyCategoryCounts(payload.categories);

    if (paginationHolder) {
      paginationHolder.innerHTML = payload.pagination_html || "";
    }

    if (resetHolder) {
      resetHolder.hidden = !hasActiveFilters(filterState);
    }
  }

  function setLoadingState(isLoading) {
    eventArchive?.classList.toggle("is-filter-loading", isLoading);
    resultsList?.setAttribute("aria-busy", isLoading ? "true" : "false");

    if (!submitButton) {
      return;
    }

    if (isLoading) {
      // Disabling guards against double submits, but disabling the element that
      // currently has focus drops focus to <body> — the next Tab would then
      // restart from the top of the document. Remember it and hand it back.
      submitHadFocus = document.activeElement === submitButton;
      submitButton.disabled = true;
      return;
    }

    submitButton.disabled = false;

    if (submitHadFocus) {
      submitHadFocus = false;
      submitButton.focus({ preventScroll: true });
    }
  }

  function resetFilterFields() {
    const startLabel = today.format(dateInputFormat);
    const endLabel = defaultEndDate.format(dateInputFormat);

    if (keyWordField) {
      keyWordField.value = "";
    }

    if (categoryField) {
      categoryField.value = "";
    }

    startpicker.setDate(startLabel, false);
    endpicker.set("minDate", startLabel);
    endpicker.setDate(endLabel, false);
    applyDateFields(today, defaultEndDate);
    clearDateInputError(startDatePicker);
    clearDateInputError(endDatePicker);
  }

  function syncFieldsToState(filterState) {
    const startLabel = filterState.start.format(dateInputFormat);
    const endLabel = filterState.end.format(dateInputFormat);

    if (keyWordField) {
      keyWordField.value = filterState.search;
    }

    if (categoryField) {
      categoryField.value = filterState.category;
    }

    startpicker.setDate(startLabel, false);
    endpicker.set("minDate", startLabel);
    endpicker.setDate(endLabel, false);
    applyDateFields(filterState.start, filterState.end);
    clearDateInputError(startDatePicker);
    clearDateInputError(endDatePicker);
  }

  function hasActiveFilters(filterState) {
    return Boolean(
      filterState.search ||
        filterState.category ||
        hasCustomDateRange(filterState)
    );
  }

  function hasCustomDateRange(filterState) {
    return (
      !filterState.start.isSame(today, "day") ||
      !filterState.end.isSame(defaultEndDate, "day")
    );
  }

  function buildRestUrl(filterState, page) {
    const url = new URL(restUrl, window.location.origin);
    url.searchParams.set("start", filterState.start.format("YYYYMMDD"));
    url.searchParams.set("end", filterState.end.format("YYYYMMDD"));

    if (filterState.search) {
      url.searchParams.set("search", filterState.search);
    }

    // The REST route names this one `category`; the archive URL uses `kategorie`.
    if (filterState.category) {
      url.searchParams.set("category", filterState.category);
    }

    if (page > 1) {
      url.searchParams.set("page", String(page));
    }

    return url.toString();
  }

  function getPageFromUrl(href) {
    const url = new URL(href || window.location.href, window.location.origin);
    const escapedPaginationBase = paginationBase.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );
    // Pretty archive links win: /veranstaltungen/page/3/… even if a stale
    // ?page=2 query arg is still hanging off the URL.
    const prettyMatch = url.pathname.match(
      new RegExp("/" + escapedPaginationBase + "/(\\d+)/?$")
    );

    if (prettyMatch) {
      return Math.max(1, parseInt(prettyMatch[1], 10) || 1);
    }

    // Plain permalinks use `paged`. Prefer it over bare `page`, which is also
    // the REST collection param and used to leak into polluted pagination hrefs.
    const pagedParam =
      url.searchParams.get("paged") ||
      url.searchParams.get("seite") ||
      url.searchParams.get("page");

    return Math.max(1, parseInt(pagedParam, 10) || 1);
  }

  // Mirrors WEISSENSTADT_EVENT_ARCHIVE_DEFAULT_MONTHS; the literal is only the
  // fallback for the case where the script runs without its localized data.
  function defaultRangeMonths() {
    const months = Number(
      window.weissenstadt_evcal_object &&
        window.weissenstadt_evcal_object.defaultMonths
    );

    return Number.isFinite(months) && months > 0 ? months : 3;
  }

  function isModifiedClick(event) {
    return (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    );
  }

  function maybeAdvanceToEndPicker() {
    // Deferred by a tick: the click that closed the start calendar is still
    // being dispatched, and flatpickr's document listener would take it as an
    // outside-click and shut the end calendar again straight away.
    window.setTimeout(function () {
      endDatePicker.focus();
      endpicker.open();
    }, 0);
  }

  function getUrlState() {
    const params = new URLSearchParams(window.location.search);

    return {
      start: parseUrlDate(params.get("start") || params.get("startdateevent")),
      end: parseUrlDate(params.get("end") || params.get("enddateevent")),
      search: (params.get("search") || params.get("keyword") || "").trim(),
      category: (params.get("kategorie") || "").trim(),
    };
  }

  function parseUrlDate(value) {
    if (!value) {
      return null;
    }

    for (const format of urlDateFormats) {
      const parsedDate = dayjs(value, format, true);

      if (parsedDate.isValid()) {
        return parsedDate;
      }
    }

    return null;
  }

  function applyDateFields(startDate, endDate) {
    startDatePicker.setAttribute("placeholder", startDate.format("DD.MM.YYYY"));
    endDatePicker.setAttribute("placeholder", endDate.format("DD.MM.YYYY"));
  }

  function getSafeEndDate(startDate, endDate) {
    return endDate.isBefore(startDate, "day") ? startDate : endDate;
  }

  function getFilterState() {
    const startDate = getPickerDay(startDatePicker);
    const selectedEndDate = getPickerDay(endDatePicker);

    if (!validateDateInput(startDatePicker, startDate)) {
      return null;
    }

    if (!validateDateInput(endDatePicker, selectedEndDate)) {
      return null;
    }

    const endDate = getSafeEndDate(startDate, selectedEndDate);

    if (endDatePicker.value !== endDate.format("DD.MM.YYYY")) {
      endpicker.setDate(endDate.format("DD.MM.YYYY"), false);
      endDatePicker.setAttribute("placeholder", endDate.format("DD.MM.YYYY"));
    }

    return {
      start: startDate,
      end: endDate,
      search: (keyWordField?.value || "").trim(),
      category: (categoryField?.value || "").trim(),
    };
  }

  function buildArchiveUrl(filterState, page) {
    const formAction =
      bookingForm?.getAttribute("action") || window.location.href;
    const url = new URL(formAction, window.location.origin);
    const postType = url.searchParams.get("post_type");
    url.search = "";

    if (usesPrettyPermalinks) {
      const escapedPaginationBase = paginationBase.replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&"
      );
      const pagePattern = new RegExp("/" + escapedPaginationBase + "/\\d+/?$");
      url.pathname = url.pathname
        .replace(pagePattern, "/")
        .replace(/\/?$/, "/");

      if (page > 1) {
        url.pathname += paginationBase + "/" + page + "/";
      }
    } else {
      if (postType) {
        url.searchParams.set("post_type", postType);
      }

      if (page > 1) {
        url.searchParams.set("paged", String(page));
      }
    }

    if (hasCustomDateRange(filterState)) {
      url.searchParams.set("start", filterState.start.format("YYYY-MM-DD"));
      url.searchParams.set("end", filterState.end.format("YYYY-MM-DD"));
    }

    if (filterState.search) {
      url.searchParams.set("search", filterState.search);
    }

    if (filterState.category) {
      url.searchParams.set("kategorie", filterState.category);
    }

    return url.toString();
  }

  function sanitizeArchiveUrl(href) {
    const url = new URL(href || window.location.href, window.location.origin);
    const allowedParams = new Set(["start", "end", "search", "kategorie"]);

    if (!usesPrettyPermalinks) {
      allowedParams.add("post_type");
      allowedParams.add("paged");
    }

    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (!allowedParams.has(key)) {
        url.searchParams.delete(key);
      }
    });

    const start = parseUrlDate(url.searchParams.get("start"));
    const end = parseUrlDate(url.searchParams.get("end"));

    if (
      start &&
      end &&
      start.isSame(today, "day") &&
      end.isSame(defaultEndDate, "day")
    ) {
      url.searchParams.delete("start");
      url.searchParams.delete("end");
    }

    url.hash = "";

    return url.toString();
  }

  function getSelectedDay(selectedDates, fallbackDate) {
    return selectedDates[0]
      ? dayjs(selectedDates[0])
      : dayjs(fallbackDate, dateInputFormat, true);
  }

  function getPickerDay(input) {
    const dateValue = input.value || input.getAttribute("placeholder") || "";
    const parsedDate = dayjs(dateValue, dateInputFormat, true);

    return parsedDate;
  }

  function validateDateInput(input, date) {
    if (date.isValid()) {
      clearDateInputError(input);
      return true;
    }

    setDateInputError(input);
    input.focus();
    return false;
  }

  function setDateInputError(input) {
    const fieldLabel = input.getAttribute("data-date-label") || "Datum";
    const message = `${fieldLabel} bitte im Format TT.MM.JJJJ eingeben.`;
    const messageElement = document.getElementById(
      input.getAttribute("data-error-id")
    );

    input.setAttribute("aria-invalid", "true");
    input.closest(".buchungsdatum")?.classList.add("has-error");

    if (messageElement) {
      messageElement.textContent = message;
    }

    setFilterStatus(message);
  }

  function clearDateInputError(input) {
    const messageElement = document.getElementById(
      input.getAttribute("data-error-id")
    );

    input.setAttribute("aria-invalid", "false");
    input.closest(".buchungsdatum")?.classList.remove("has-error");

    if (messageElement) {
      messageElement.textContent = "";
    }
  }

  function setFilterStatus(message) {
    if (filterStatus) {
      filterStatus.textContent = message;
    }
  }

  function improveDatepickerAccessibility(instance, label) {
    instance.calendarContainer?.setAttribute("aria-label", label);
    instance.prevMonthNav?.setAttribute("aria-label", "Vorheriger Monat");
    instance.prevMonthNav?.setAttribute("title", "Vorheriger Monat");
    instance.nextMonthNav?.setAttribute("aria-label", "Nächster Monat");
    instance.nextMonthNav?.setAttribute("title", "Nächster Monat");
  }

  function setViewMode(mode) {
    const isListView = mode === "list";

    eventContent.classList.toggle("listview", isListView);
    listButton?.classList.toggle("evcaltoggler", isListView);
    gridButton?.classList.toggle("evcaltoggler", !isListView);
    listButton?.setAttribute("aria-pressed", isListView ? "true" : "false");
    gridButton?.setAttribute("aria-pressed", isListView ? "false" : "true");
  }
});
